




import { Vue, Component } from 'vue-property-decorator'
import Countdown from '@/components/tools/Countdown.vue'

// 30 minutes
const DEFAULT_DURATION = 30 * 60

@Component({
  components: {
    Countdown
  }
})
export default class CountdownView extends Vue {
  // data
  private duration: number = 0

  created () {
    this.duration = parseInt(this.$route.params.duration) || DEFAULT_DURATION
  }
}
